import React from 'react'

const MarketPlaceCourses = () => {
    return (
        <div className="flex flex-col gap-4 flex-1 w-full">
            <section className="w-full rounded-2xl border border-gray-200 bg-white p-6 shadow-sm transition-all duration-200 hover:shadow-md hover:border-gray-300">
                <div className="flex items-center gap-3 p-4 bg-[#e8f0f7] rounded-xl mb-6">
                    <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
                        <svg
                            className="w-5 h-5 text-[#0f6abf]"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M12 6v13m0-13c-1.657 0-3 .672-4 1.5S6 9 6 9v11s1-1 4-1 4 1 4 1V9s-1-.672-2-1.5-2.343-1.5-4-1.5zm0 0c1.657 0 3 .672 4 1.5S18 9 18 9v11s-1-1-4-1-4 1-4 1"
                            />
                        </svg>
                    </div>
                    <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2 flex-wrap">
                            <div className="text-sm font-semibold text-gray-900 break-words">
                                Courses
                            </div>
                            <div className="text-xs text-gray-500 break-words">
                                University
                                {/* University ↔ Industry */}
                            </div>
                        </div>
                    </div>

                </div>
            </section>
        </div>
    )
}

export default MarketPlaceCourses
